import React, { useEffect, useMemo, useState } from 'react'
import styles from './index.module.less'
import ModuleItem from '@/components/moduleItem/index'
import Title from '@/components/BlockTitleTwo'
import icon from '@/assets/image/gea/countryRegion.svg'
import SearchInput from '@/components/SearchInputTwo'
import CountryImg from '@/assets/image/countryRegion/country.png'
import BlockHeightImg from '@/assets/image/countryRegion/block-height.png'
import VerifiedAddressImg from '@/assets/image/countryRegion/verified-address.png'
import MainInfo from './components/mainInfo/indexTwo'
import SecondaryCard from './components/secondaryCard'
import {
  getRegionStatistic,
  getBlockAverageBlockTime,
  getBlockTransactionList,
  getRegionList,
  getRegionStatisticNew,
} from '@/api/region/index'
import {
  type RegionState,
  type I_StatsData,
  StatisticNew_Response,
  Region_List_Item,
} from '@/api/region/types'
import { useTranslation } from 'react-i18next'
import { isEmptyOrNil } from '@/utils'
import LoadingCom from '@/components/LoadingCom'
const CountryRegion: React.FC = () => {
  const { t } = useTranslation()
  const [loading, setLoading] = useState<boolean>(true)
  const [regionStatistic, setRegionStatistic] = useState<StatisticNew_Response | null>(null)
  const [regionList, setRegionList] = useState<Region_List_Item[]>([])
  const [blockAverageBlockTime, setBlockAverageBlockTime] = useState<number | null>(null)
  const showMainInfo = true

  /**
   * 查询区域列表 list
   */
  // const getRegionListFn = async () => {
  //   const res = await getBlockTransactionList()
  //   setRegionList(res?.region_states)
  // }

  const getRegionListFnNew = async () => {
    const res = await getRegionList()
    setRegionList(res?.list)
    setLoading(false)
  }

  /**
   * 获取区总的质押统计信息 statistic
   */
  // const getRegionStatisticFn = async () => {
  //   const res = await getRegionStatistic()
  //   if (res) {
  //     setRegionStatistic(res)
  //   }
  // }

  const getRegionStatisticNewFn = async () => {
    const res = await getRegionStatisticNew()
    if (res) {
      setRegionStatistic(res)
    }
  }

  /**
   * 查询平均出块时间（按小时统计）和最新区块高度
   */
  const getBlockAverageBlockTimeFn = async () => {
    const res = await getBlockAverageBlockTime()
    if (res) {
      setBlockAverageBlockTime(res?.block[0].latest_block)
    }
  }

  useEffect(() => {
    // getRegionStatisticFn()
    getRegionStatisticNewFn()
    // getRegionListFn()
    getRegionListFnNew()
    getBlockAverageBlockTimeFn()
  }, [])

  // const current_kyc_amount = useMemo(() => {
  //   const value = regionStatistic?.total_kyc_count?.aggregate?.sum?.current_kyc_amount
  //   if (isEmptyOrNil(value)) return '-'
  //   return value as number
  // }, [regionStatistic])
  return (
    <div className={styles.country_region_page}>
      <div className={styles.titleWrap}>
        {/* 国家/区 */}
        <Title title={t('explorer_1')} icon={icon} />
        <div className="search_input">
          <SearchInput placeholder={t('explorer_8')} />
        </div>
      </div>
      {/*内容区*/}
      {showMainInfo ? (
        <>
          <div className={styles.country_content_area}>
            <div className={styles.content_area_left}>
              <div className={styles.area_left_list}>
                {/* <ModuleItem
                  //  国家/区
                  title={t('explorer_39')}
                  // value={regionStatistic?.region_count?.aggregate?.count || '-'}
                  value={regionStatistic?.regionCount || '-'}
                  img={CountryImg}
                ></ModuleItem> */}
                {/* <div className={styles.list_line}></div> */}
                {/* 最新区块高度 */}
                {/* explorer_40 最新区块高度 */}
                <ModuleItem
                  title={t('explorer_40')}
                  fieldKey={'block_height'}
                  value={blockAverageBlockTime || '-'}
                  img={BlockHeightImg}
                ></ModuleItem>
                {/* <div className={styles.list_line}></div> */}
                {/* 已认证地址 */}
                {/* <ModuleItem
                  title={t('explorer_16')}
                  value={current_kyc_amount}
                  img={VerifiedAddressImg}
                ></ModuleItem> */}
              </div>
            </div>
            <div className={styles.content_area_right}>
              <MainInfo regionStatistic={regionStatistic} />
            </div>
          </div>
        </>
      ) : null}
      <div className="secondary_card_list">
        {loading && <LoadingCom></LoadingCom>}
        {regionList?.length
          ? regionList.map((item, index) => {
              return (
                <SecondaryCard
                  key={item.regionId}
                  cardInfo={item as any}
                  index={index + 1}
                ></SecondaryCard>
              )
            })
          : null}
      </div>
    </div>
  )
}

export default CountryRegion
